import { ShieldCheck } from '@phosphor-icons/react';

import { cn } from '../../utils/cn';
import pt from '../../locales/pt';

export function LandingRiskLine({ className }) {
  return (
    <p
      className={cn(
        'inline-flex items-center gap-space-2 type-body-sm text-muted-foreground',
        className,
      )}
    >
      <ShieldCheck className="h-4 w-4 shrink-0 text-sage-700 dark:text-sage-300" aria-hidden />
      <span>{pt.landing.riskLine}</span>
    </p>
  );
}
